/*
 * Name: Image Uploader
 * Desc:
 *
 */
import { Auth } from "aws-amplify"
import axios from "axios"
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size"
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type"
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation"
import FilePondPluginImagePreview from "filepond-plugin-image-preview"
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css"
import FilePondPluginImageValidateSize from "filepond-plugin-image-validate-size"
import "filepond/dist/filepond.min.css"
import React, { useEffect, useState } from "react"
import { FilePond, registerPlugin } from "react-filepond"
import * as styles from "./ImageUploader.module.scss"
import lambdas from "@data/lambdas"

// Register the plugins
registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateSize,
  FilePondPluginFileValidateType,
  FilePondPluginImageValidateSize
)

const { IMAGE_UPLOAD, IMAGE_UPLOAD_URL } = lambdas[process.env.NEXT_PUBLIC_ENV]

// Our app
const ImageUploader = (props) => {
  const [files, setFiles] = useState([])
  const handleFileChange = (id, isAdding) => {
    setFiles((prevFiles) => (isAdding ? [...prevFiles, id] : prevFiles.filter((idFile) => idFile !== id)))
  }

  // sync changes to files state with parent element
  useEffect(() => {
    props.handleChangeFile(props.allowMultiple ? files : files[0], props.name)
  }, [files])

  const getUploadRequest = async (file) => {
    const user = await Auth.currentSession()
    const response = await fetch(IMAGE_UPLOAD_URL, {
      method: "POST",
      body: JSON.stringify({
        sessionToken: user.getIdToken().getJwtToken(),
        filename: file.name,
      }),
    })
    if (response.ok) {
      const data = await response.json()
      return data
    }
    alert(
      "There has been an error, please refresh the page and try again. If it persists please contact us at supplier@houseofpartyplanning.com"
    )
    return false
  }

  const createUpload = async (id) => {
    const response = await fetch(IMAGE_UPLOAD, {
      method: "POST",
      body: JSON.stringify({
        path: id,
      }),
    })
    if (response.ok) {
      const data = await response.json()
      return data
    }
    alert(
      "There has been an error, please refresh the page and try again. If it persists please contact us at supplier@houseofpartyplanning.com"
    )
    return false
  }

  const filePondProcessFile = {
    process: async (fieldName, file, metadata, load, error, progress, abort) => {
      const uploadRequest = await getUploadRequest(file)
      await axios
        .request({
          method: "PUT",
          url: uploadRequest.url,
          data: file,
          onUploadProgress: (p) => {
            progress(p.lengthComputable, p.loaded, p.total * 1.11)
            props.disableSubmit(true)
          },
        })
        .then(async (response) => {
          let count = 90
          const ticker = setInterval(() => {
            progress(true, count++ < 100 ? count : 99, 100)
            props.disableSubmit(true)
          }, 600)
          const upload = await createUpload(uploadRequest.id)
          handleFileChange(upload.id, true)
          clearInterval(ticker)
          progress(true, 100, 100)
          load(upload.id)
        })
      return {
        abort: () => {
          abort()
        },
      }
    },
    revert: (uniqueFileId, load, error) => {
      // TODO add Remove lambda to delete datoupload, however this may be a security risk
      // https://www.datocms.com/docs/content-management-api/resources/upload#destroy
      load()
      handleFileChange(uniqueFileId, false)
    },
  }

  return (
    <FilePond
      required={props.required}
      className={styles.ImageUploader}
      name={props.name}
      maxFileSize="3MB"
      imageValidateSizeMinWidth={1600}
      imageValidateSizeLabelExpectedMinSize="Minimum width is {minWidth}"
      acceptedFileTypes={["image/png", "image/jpeg", "image/jpg"]}
      server={filePondProcessFile}
      allowMultiple={props.allowMultiple}
      onprocessfiles={() => props.disableSubmit(false)}
      onaddfilestart={() => props.disableSubmit(true)}
      onerror={() => props.disableSubmit(false)}
    />
  )
}

export default ImageUploader
